import anchorme from "anchorme";
import { Observer } from 'mobx-react-lite';
import React from 'react';
import joinClassName from '../../utils/className.utils';
import { useProps, useStore } from "../../utils/mobx.utils";
import { sanitize } from '../../utils/sanitizer.utils';
import './BodyCopyRenderer.scss';
var BodyCopyRenderer = function (props) {
    var p = useProps(props);
    var s = useStore(function () { return ({
        get html() {
            return anchorme({
                input: p.source || '',
                options: {
                    attributes: {
                        target: "_blank",
                    },
                },
            });
        },
        get sanitizedHtml() {
            return sanitize(s.html);
        },
        get style() {
            return p.lineClamp ? {
                display: '-webkit-box',
                WebkitLineClamp: p.lineClamp,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            } : {};
        }
    }); });
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName('BodyCopyRenderer', p.className), dangerouslySetInnerHTML: { __html: s.sanitizedHtml }, style: s.style, "data-cy": p.dataCy })); } });
};
export default BodyCopyRenderer;
